var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 18v3a1 1 0 0 0 1 1h3a1 1 0 0 0 .707-.293l14-14a1 1 0 0 0 .293-.707 4 4 0 0 0 -4-4 1 1 0 0 0 -.707.293l-14 14a1 1 0 0 0 -.293.707zm15.378-12.964a2 2 0 0 1 1.586 1.586l-1.964 1.964-1.586-1.586zm-13.378 13.378 10-10 1.586 1.586-10 10h-1.586z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m27.186 11.564a1 1 0 0 0 -.661 1.25 10.8 10.8 0 0 1 .475 3.186 11 11 0 1 1 -11-11 10.8 10.8 0 0 1 3.186.475 1 1 0 0 0 .589-1.911 12.756 12.756 0 0 0 -3.775-.564 13 13 0 1 0 13 13 12.756 12.756 0 0 0 -.564-3.775 1 1 0 0 0 -1.25-.661z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreated);
export default __webpack_public_path__ + "static/media/created.7f8cfba7ef1d5641bd811bc41ace531e.svg";
export { ForwardRef as ReactComponent };